export const API_URL_VINAPHONE = 'https://api.khoso.com.vn/api';
export const API_URL_SIMSO = 'https://api.khoso.com.vn/api_sim';
// export const API_URL_VINAPHONE = 'http://localhost:3000/api';
// export const API_URL_SIMSO = 'http://localhost:3000/api_sim';
export const API_URL_TT = 'https://apiwin.khoso.com.vn';
export const API_URL_GOOGLESHEETS = 'https://script.google.com/macros/s/';
//
